import { defineStore } from "pinia";
import { computed, nextTick, ref } from "vue";
import { StorageHelper } from "@/utils/StorageHelper";
import { StorageName } from "@/utils/StorageHelper/constants";

export const useLoginHistoryStore = defineStore("loginHistoryStore", () => {
    const loginHistory = ref<Date[]>([]);

    const { read, write, remove } = new StorageHelper(StorageName.LoginHistory);

    const add = async (date: Date) => {
        loginHistory.value.push(date);

        await nextTick();

        write(loginHistory.value);
    };

    const reset = async () => {
        loginHistory.value = [];

        remove();

        await nextTick();

        return Promise.resolve();
    };

    const restoreFromStorage = () => {
        const history = read<Date[]>();

        if (!history) return;

        loginHistory.value = history.map((date) => new Date(date));
    };

    const initialize = async () => {
        restoreFromStorage();

        await nextTick();

        return Promise.resolve();
    };

    const previousLogin = computed(() => {
        if (!loginHistory.value.length) return undefined;

        return loginHistory.value[1];
    });

    return { loginHistory, add, reset, initialize, previousLogin };
});
